export default {
  'audit.overview.pageTitle': '财务审核',
  'audit.overview.pageDescription': '查看财务和物业待审核的统计数据',
  'audit.overview.tab.recent30': '最近30天',
  'audit.overview.tab.allData': '全部数据',
  'audit.overview.dataUpdatedJustNow': '数据更新: 刚刚',
  'audit.overview.action.refresh': '刷新',
  'audit.overview.action.startAudit': '开始审批',
  'audit.overview.tag.urgent': '紧急',
  'audit.overview.tag.normal': '常规',
  'audit.overview.metric.pendingCount': '待处理笔数',
  'audit.overview.metric.totalAmount': '涉及总金额',
  'audit.overview.metric.pendingAmount': '待审金额',
  'audit.overview.metric.overdueCount': '逾期 {count} 笔',
  'audit.overview.metric.noOverdue': '无逾期',
  'audit.overview.card.pendingReceivablesCount.title': '待收款笔数',
  'audit.overview.card.pendingReceivablesCount.subTitle': '当前待处理总量',
  'audit.overview.card.pendingReceivablesAmount.title': '待收款金额',
  'audit.overview.card.pendingReceivablesAmount.subTitle': '全平台应收',
  'audit.overview.card.overdueCount.title': '逾期未缴笔数',
  'audit.overview.card.overdueCount.subTitle': '高风险预警',
  'audit.overview.card.overdueAmount.title': '逾期涉及金额',
  'audit.overview.card.overdueAmount.subTitle': '坏账风险统计',
  'audit.overview.section.financeAndApplicationAudit': '财务花销与申请审核',
  'audit.overview.section.feeAuditMatrix': '细分费用审计矩阵',
  'audit.overview.finance.title': '财务待审核',
  'audit.overview.property.title': '物业待审核',
  'audit.overview.total.label': '待审核总数',
  'audit.overview.total.unit': '条',
  'audit.overview.feeType.label': '费用类型',
  'audit.overview.count.label': '待审核数量',
  'audit.overview.action.label': '操作',
  'audit.overview.action.view': '查看详情',
  'audit.overview.action.viewOnly': '查看',
  'audit.overview.empty': '暂无待审核记录',
  'audit.overview.drawer.title.financialExpense': '财务花销审核',
  'audit.overview.drawer.title.budgetRequest': '预算申请审核',
  'audit.overview.drawer.title.mortgageRepayment': '房贷还款审核',
  'audit.overview.drawer.title.carRepayment': '车贷还款审核',
  'audit.overview.drawer.title.default': '财务审核',
  'audit.overview.drawer.tab.reviewLater': '关注审核',
  'audit.overview.drawer.error.loadStatusStatistics': '加载审核状态统计失败',
  'audit.overview.drawer.message.getDetailFailed': '获取单据详情失败',
  'audit.overview.drawer.message.unsupportedEdit': '该类型单据暂不支持编辑',
};
